/**
 * 菜单数据
 * @type {*[]}
 */
export const menuList = [
    // {
    //     icon:'ios-analytics',
    //     name:'仪表盘',
    //     visible:false,
    //     childNode:[]
    // },
    {
        icon:'icon-work-flow',
        name:'智能工作流',
        iconName:'工作流',
        visible:false,
        sortNumber:1,
        menuCode:'site-inspection',
        childNode:[
            {
                name:'作业流程',
                link:'/workflow/process/list',
            },
            {
                name:'作业任务',
                link:'/workflow/task',
            },
            // {
            //     name:'作业任务',
            //     link:'/workflow/guidance/task',
            // },
            {
                name:'作业记录',
                link:'/workflow/record/list',
            },
        ]
    },
    // {
    //     icon:'icon-location',
    //     name:'定位管理',
    //     iconName:'定位管理',
    //     visible:false,
    //     sortNumber:2,
    //     menuCode:'location-service',
    //     childNode:[
    //         {
    //             name:'定位资源配置',
    //             link:'/location/list',
    //         }
    //     ]
    // },
    {
        icon:'icon-device',
        name:'知识库',
        iconName:'知识库',
        sortNumber:3,
        visible:false,
        menuCode:'knowledge-base-service',
        childNode:[
            {
                name:'设备知识库',
                link:'/device/list',
            },
            {
                name:'档案管理库',
                link:'/archive/list',
            }
        ]
    },
    {
        icon:'icon-conversation',
        name:'远程协作',
        iconName:'远程协作',
        sortNumber:4,
        visible:false,
        menuCode:'conversation-websocket',
        childNode:[
            {
                name:'远程协作',
                link:'/collaboration/list',
            }
        ]
    },
    {
        icon:'icon-user-center',
        name:'系统管理',
        iconName:'系统管理',
        visible:false,
        sortNumber:4,
        menuCode:'user-center',
        childNode:[
            {
                name:'定位资源配置',
                link:'/location/list',
            },
            {
                name:'账号管理',
                link:'/account/list',
            },
        ]
    },
]

/**
 * 系统菜单数据
 * @type {*[]}
 */
export const systemMenuList = [
    // {
    //     icon:'ios-analytics',
    //     name:'仪表盘',
    //     visible:false,
    //     childNode:[]
    // },
    {
        icon:'ios-home',
        name:'企业管理',
        sortNumber:1,
        menuCode:'enterprise',
        visible:true,
        childNode:[
            {
                name:'企业账号',
                link:'/business',
            },
            {
                name:'模型管理',
                link:'/model/list',
            }
        ]
    }
]

/**
 * 上传类型
 * @type {{}}
 */
export const systemUploadType = {
    knowledge_image:'knowledge_image', //知识库图片
    conversation_session_image:'conversation_session_image', //远程指导图片
    inspection_node_image:'inspection_node_image', //安全巡检节点图片
    inspection_results_image:'inspection_results_image', //安全巡检结果图片
    inspection_results_voice:'inspection_results_voice', //安全巡检结果语音
    inspection_results_video:'inspection_results_video', //安全巡检结果录像
    user_avatar_image:'user_avatar_image', //用户头像图片
    inspection_annex:'inspection_annex',
    system_app:'system_app', //系统app版本
}

/**
 * 演示配置
 * @type {{DEMONSTRATE: string, NORMAL: string}}
 */
export const systemPublishEnum = {
    DEMONSTRATE:'DEMONSTRATE', // 演示无logo
    NORMAL:'NORMAL', //正常有logo
}

/**
 * 配置演示状态
 * @type {string}
 */
export const systemPublishLogo = systemPublishEnum.DEMONSTRATE
